import { render, staticRenderFns } from "./packList.vue?vue&type=template&id=4cd49836&scoped=true"
import script from "./packList.vue?vue&type=script&lang=js"
export * from "./packList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd49836",
  null
  
)

export default component.exports